import { useMemo } from 'react';
import { motion } from 'motion/react';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './Advt.module.css';

import defaultBackground from '../../assets/images/bgPoster.png';

export const Advt = () => {
  const { title, titleFontSize, bg } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div className={styles.advtWrapper} style={{ background }}>
      {title && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className={styles.title}
          style={{
            fontSize: `${titleFontSize}rem`,
          }}
        >
          {title}
        </motion.div>
      )}
    </div>
  );
};
